'use client';

import { forwardRef } from 'react';
import NextImage, { type ImageProps as NextImageProps } from 'next/image';

type ImageSource = NextImageProps['src'];

function resolveImageSource(src: ImageSource) {
  if (typeof src === 'string') return src;

  if ('src' in src && typeof src.src === 'string') return src.src;

  if ('default' in src && typeof src.default?.src === 'string') return src.default.src;

  return '';
}

function isSvgSource(src: ImageSource) {
  const pathname = resolveImageSource(src).split(/[?#]/)[0];

  return pathname.toLowerCase().endsWith('.svg');
}

const Image = forwardRef<HTMLImageElement, NextImageProps>(function Image(
  { src, unoptimized, ...props },
  forwardedRef
) {
  return (
    <NextImage
      {...props}
      ref={forwardedRef}
      src={src}
      // Next 14.2 throws ERR_HTTP_HEADERS_SENT when the optimizer handles an SVG.
      unoptimized={unoptimized || isSvgSource(src)}
    />
  );
});

export { type NextImageProps as ImageProps, Image };
export default Image;
